var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
// import MicrosoftLogo from "./microsoft-logo.png";
import { PublicClientApplication } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@sal/authentication.react";
import { Button } from "@mui/material";
import { usePortalFramework } from "../../PortalFramework";
export const LoginWithMicrosoftButton = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const portalFramework = usePortalFramework();
    if (!((_b = (_a = portalFramework.settings) === null || _a === void 0 ? void 0 : _a.microsoftSsoSettings) === null || _b === void 0 ? void 0 : _b.clientID) ||
        !((_d = (_c = portalFramework.settings) === null || _c === void 0 ? void 0 : _c.microsoftSsoSettings) === null || _d === void 0 ? void 0 : _d.authority) ||
        !((_f = (_e = portalFramework.settings) === null || _e === void 0 ? void 0 : _e.microsoftSsoSettings) === null || _f === void 0 ? void 0 : _f.redirectUrl)) {
        return (_jsx("div", {}));
    }
    const navigate = useNavigate();
    const auth = useAuth();
    const config = {
        auth: {
            clientId: portalFramework.settings.microsoftSsoSettings.clientID,
            authority: portalFramework.settings.microsoftSsoSettings.authority
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false
        }
    };
    const loginRequest = {
        scopes: portalFramework.settings.microsoftSsoSettings.scopes,
        prompt: "select_account",
        redirectUri: portalFramework.settings.microsoftSsoSettings.redirectUrl
    };
    function login(idToken) {
        if (idToken) {
            auth.loginWithMicrosoft(idToken, login_callback);
        }
        else {
            props.setMessage("Error logging in with Microsoft");
        }
    }
    ;
    const login_callback = (response) => {
        if (response.success) {
            navigate("/");
        }
        else {
            props.setMessage(response.message);
        }
    };
    function getUserData() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const publicClientApplication = new PublicClientApplication(config);
                yield publicClientApplication.initialize();
                var data = yield publicClientApplication.loginPopup(loginRequest);
                login(String(data.idToken));
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    return (_jsx(Button, Object.assign({}, props.buttonProps, { onClick: getUserData, children: _jsx("div", { style: { width: "80%", float: "right", height: "100%" }, children: "Sign in with Microsoft" }) })));
};
